/**
 * Błędy
 *
 * @export
 * @enum {number}
 */
export enum Errors {
  ACCOUNT_CANNOT_CONFIRM = 'Nie udało się potwierdzić twojego konta.',
  ACTION_FAILED = 'Nie udało się wykonać akcji.',
  ACTIONS_CANNOT_REFRESH = 'Nie udało się odświeżyć akcji.',
  ASSESSMENT_CANNOT_SAVE = 'Wystąpił błąd przy zapisie oceny',
  ATTACHMENT_CANNOT_LIST = 'Wystąpił błąd podczas ładowania listy załączników.',
  ATTACHMENT_CANNOT_SAVE = 'Nie udało się zapisać załącznika.',
  ATTACHMENT_LIMIT_EXCEEDED = 'Przekroczono limit załączników.',
  ATTACHMENTS_CANNOT_SAVE = 'Nie udało się zapisać załączników.',
  AUTH_INCORRECT_LOGIN = 'Niepoprawny login i/lub hasło',
  AUTH_CANNOT_LOAD_DATA = 'Wystąpił błąd podczas ładowania danych użytkownika.',
  AUTH_CANNOT_SET_PASSWORD = 'Nie udało się ustawić nowego hasła.',
  BUTTON_CANNOT_REMOVE = 'Nie udało się usunąć przycisku.',
  BUTTON_CANNOT_LIST = 'Nie udało się pobrać listy przycisków.',
  BUTTON_CANNOT_SAVE = 'Nie udało się zapisać przycisku.',
  CANNOT_GET_DATA = 'Nie udało się pobrać danych.',
  CANNOT_GET_DICTIONARY = 'Nie udało się pobrać słownika.',
  CANNOT_GO_TO_MESSAGE_ENTITY = 'Nie udało się przejść do obiektu powiadomienia.',
  CONTACT_WITH_KSAT_ADMIN = 'Skontaktuj się z administratorem KSAT-a.',
  CHECK_SELECTED_DATA = 'Sprawdź poprawność zaznaczonych danych.',
  CONTEST_CANNOT_LIST = 'Nie udało się pobrać listy konkursów.',
  CONTEST_CANNOT_SAVE = 'Nie udało się zapisać konkursu.',
  CONTEST_LEVEL_NOT_SELECTED = 'Nie wybrano typu szkoły.',
  CONTEST_TYPE_NOT_SELECTED = 'Nie wybrano rodzaju konkursów.',
  CRITERION_CANNOT_LIST = 'Wystąpił błąd podczas ładowania listy kryteriów.',
  DECISION_CANNOT_LIST = 'Wystąpił błąd podczas pobierania listy decyzji.',
  DOCUMENT_ALREADY_EDITING = 'Inny użytkownik już edytuje ten wniosek.',
  DOCUMENT_CANNOT_GET = 'Wystąpił błąd podczas pobierania wniosku.',
  DOCUMENT_CANNOT_LIST = 'Wystąpił błąd podczas ładowania listy wniosków.',
  DOCUMENT_CANNOT_REMOVE = 'Nie udało się usunąć wniosku.',
  DOCUMENT_CANNOT_SET_STATUS = 'Wystąpił błąd podczas zapisu statusu wniosku.',
  DOCUMENT_CANNOT_SET_STATUSES = 'Wystąpił błąd podczas zapisu statusów wniosków.',
  DOCUMENT_MDOK_CANNOT_GET = 'Wystąpił błąd podczas pobierania dokumentu.',
  DOCUMENT_PACK_CANNOT_ADD = 'Wystąpił błąd podczas tworzenia paczki wniosków.',
  DOCUMENT_PACK_CANNOT_GET = 'Wystąpił błąd podczas pobierania danych paczki wniosków.',
  DOCUMENT_PACK_CANNOT_LIST = 'Wystąpił błąd podczas pobierania paczek wniosków.',
  DOCUMENT_PACK_CANNOT_RECEIVE = 'Wystąpił błąd podczas odbierania paczki wniosków.',
  DOCUMENT_VALUE_ADD_ERROR = 'Wystąpił błąd podczas tworzenia wartości dokumentu.',
  DOCUMENT_VALUE_CANNOT_GET = 'Wystąpił błąd podczas pobierania danych wartości dokumentu.',
  DOCUMENT_VALUE_UPDATE_ERROR = 'Wystąpił błąd podczas aktualizacji wartości dokumentu.',
  ERROR_TRY_AGAIN_LATER = 'Wystąpił błąd. Spróbuj ponownie później.',
  EVENT_CANNOT_LIST = 'Wystąpił błąd podczas ładowania listy zdarzeń.',
  FILE_NAME_DUPLICATE = 'Powtórzony plik o nazwie:',
  FILE_SIZE_TOO_BIG = 'Zbyt duży rozmiar pliku.',
  FILE_TYPE_NOT_ACCEPTED = 'Nieprawidłowe rozszerzenie pliku.',
  FILE_UPLOAD_FAILED = 'Nie udało się dodać pliku.',
  FORM_CANNOT_GET = 'Wystąpił błąd podczas ładowania danych formularza.',
  FORM_CANNOT_SAVE = 'Wystąpił błąd podczas zapisu.',
  FORM_CORRECT_ERRORS = 'Należy poprawić błędy w formularzu.',
  FORM_INCORRECTLY_COMPLETED = 'Błędnie wypełniony formularz.',
  GDPR_CANNOT_GET = 'Nie udało się pobrać polityki RODO.',
  HISTORY_CANNOT_LIST = 'Nie udało się pobrać historii.',
  INVOICE_CANNOT_ADD = 'Nie udało się dodać dokumentu księgowego.',
  INVOICE_CANNOT_DELETE = 'Nie udało się usunąć dokumentu księgowego.',
  INVOICE_CANNOT_GET = 'Nie udało się pobrać danych dokumentu księgowego.',
  INVOICE_CANNOT_LIST = 'Nie udało się pobrać listy dokumentów księgowych.',
  INVOICE_CANNOT_UPDATE = 'Nie udało się zaktualizować danych dokumentu księgowego.',
  KO_PROPOSAL_CANNOT_SEND = 'Nie udało się wysłać wniosku KO.',
  MAIL_TEMPLATE_ADD_ERROR = 'Nie udało się dodać szablonu wiadomości e-mail.',
  MAIL_TEMPLATE_CANNOT_GET = 'Wystąpił błąd podczas pobierania szablonu wiadomości e-mail.',
  MAIL_TEMPLATE_CANNOT_LIST = 'Wystąpił błąd podczas ładowania listy szablonów wiadomości e-mail.',
  MAIL_TEMPLATE_DELETE_ERROR = 'Nie udało się usunąć szablonu wiadomości e-mail.',
  MAIL_TEMPLATE_UPDATE_ERROR = 'Nie udało się zaktualizować danych szablonu wiadomości e-mail.',
  MDOK_LINK_FAILED = 'Nie udało się pobrać adresu wniosku w MDOK.',
  MODULE_CANNOT_LIST = 'Wystąpił błąd podczas ładowania listy modułów.',
  OPTION_CANNOT_UPDATE = 'Nie udało się edytować opcji.',
  PAYMENT_CANNOT_CANCEL = 'Nie udało się anulować zobowiązania.',
  PAYMENT_CANNOT_REATTACH = 'Nie udało się dołączyć zobowiązania do paczki dokumentów.',
  PAYMENT_CANNOT_RESEND = 'Nie udało się ponownie przesłać zobowiązania do KSAT.',
  PAYMENT_LIST_CANNOT_GET = 'Nie udało się pobrać listy płatności.',
  PAYMENT_LIST_CANNOT_SAVE = 'Nie udało się zapisać listy wypłat.',
  PAYMENT_PACK_CANNOT_LIST = 'Nie udało się pobrać listy paczek płatności.',
  PERMISSION_CANNOT_LIST = 'Nie udało się pobrać uprawnień.',
  PLAN_CANNOT_GET = 'Nie udało się pobrać planu rocznego.',
  PROCEDURE_CANNOT_CREATE = 'Nie udało się utworzyć procedury.',
  PROCEDURE_CANNOT_DELETE = 'Nie udało się usunąć procedury.',
  PROCEDURE_CANNOT_GET = 'Nie udało się pobrać procedury.',
  PROCEDURE_CANNOT_LIST = 'Wystąpił błąd podczas ładowania listy procedur.',
  PROCEDURE_CANNOT_SET_STATUS = 'Wystąpił błąd podczas zapisu statusu procedury.',
  PROFILE_CANNOT_GET = 'Nie udało się pobrać danych profilu.',
  PROFILE_CANNOT_LIST = 'Nie udało się pobrać listy profili.',
  PROFILE_CANNOT_LIST_ROLES = 'Nie udało się pobrać ról użytkownika.',
  REPORT_CANNOT_GET = 'Nie udało się pobrać raportu.',
  ROLE_CANNOT_GRANT = 'Nie udało się przyznać roli.',
  ROLE_CANNOT_LIST = 'Nie udało się pobrać ról.',
  ROLE_CANNOT_REMOVE = 'Nie udało się usunąć roli.',
  ROLE_CANNOT_REVOKE = 'Nie udało się odebrać roli.',
  SCHEMA_CANNOT_LIST = 'Wystąpił błąd podczas ładowania listy schem.',
  SCHOOL_NOT_SELECTED = 'Należy wybrać szkołę.',
  SETTING_CANNOT_LIST = 'Wystąpił błąd podczas ładowania listy ustawień.',
  SETTING_CANNOT_GET = 'Wystąpił błąd podczas ładowania ustawienia.',
  SETTING_CANNOT_UPDATE = 'Nie udało się zaktualizować danych ustawienia.',
  SETTING_NOT_FOUND = 'Nie znaleziono ustawienia.',
  STATISTICS_CANNOT_GET = 'Nie udało się pobrać statystyk.',
  STRUCTURE_CANNOT_ADD = 'Nie udało się dodać jednostki oświatowej.',
  STRUCTURE_CANNOT_DELETE = 'Nie udało się usunąć jednostki oświatowej.',
  STRUCTURE_CANNOT_GET = 'Wystąpił błąd podczas pobierania danych jednostki oświatowej.',
  STAGE_CANNOT_LIST = 'Wystąpił błąd podczas ładowania listy etapów.',
  STAGE_CANNOT_LIST_OPTIONS = 'Wystąpił błąd podczas ładowania opcji etapu.',
  STATUS_CANNOT_LIST = 'Wystąpił błąd podczas pobierania listy statusów.',
  STRUCTURE_CANNOT_LIST = 'Wystąpił błąd podczas ładowania struktury.',
  STRUCTURE_CANNOT_UPDATE = 'Nie udało się zaktualizować danych jednostki oświatowej.',
  STUDENT_NOT_FOUND = 'Nie odnaleziono ucznia w bazie UONET, wprowadź dane ręcznie lub skontaktuj się z administratorem aplikacji.',
  SYSTEM_MESSAGE_CANNOT_GET = 'Wystąpił błąd podczas ładowania powiadomienia.',
  SYSTEM_MESSAGE_CANNOT_LIST = 'Wystąpił błąd podczas ładowania listy powiadomień.',
  TABLE_CANNOT_SWAP = 'Nie udało się zmienić kolejności.',
  TEMPLATE_CANNOT_GET = 'Wystąpił błąd podczas ładowania wzoru procedury.',
  TEMPLATE_CANNOT_LIST = 'Wystąpił błąd podczas ładowania listy wzorów.',
  TEMPLATE_CANNOT_LIST_STATUS = 'Wystąpił błąd podczas ładowania statusów wzoru procedury.',
  VIEW_ADD_ERROR = 'Nie udało się dodać widoku.',
  VIEW_CANNOT_GET = 'Wystąpił błąd podczas pobierania widoku.',
  VIEW_CANNOT_LIST = 'Wystąpił błąd podczas ładowania listy widoków.',
  VIEW_DELETE_ERROR = 'Nie udało się usunąć widoku.',
  VIEW_UPDATE_ERROR = 'Nie udało się zaktualizować danych widoku.'
}
